<template>
    <v-form v-model="valid">
        <v-text-field :label='$t("labelStrategyName")' v-model="strategyName" :rules="nameRule" counter outlined/>
        <v-text-field :label='$t("labelStrategyDescription")' v-model="strategyDescription" :rules="descriptionRule" counter outlined/>
        <v-btn :disabled="!valid" @click="addStrategy">{{ $t('addStrategy_OwnStrategy') }}</v-btn>
    </v-form>
</template>

<script>
    import Repository from '../../repositories/strategy';
    import { mapMutations } from 'vuex';
    export default {
        name: "OwnStrategy",
        data() {
            return {
                // Data
                strategyName: '',
                strategyDescription: '',

                // Rules
                valid: false,
                nameRule: [
                    r => !! r  || this.$t('watchlistNameRequired'),
                    r => r.length < 28 || this.$t('maxCharacters',{number: 28}),
                ],
                descriptionRule: [
                    d => d.length < 42 || this.$t('maxCharacters',{number: 42}),
                ],
            };
        },
        methods: {
            ...mapMutations(['setStrategies']),
            addStrategy(){
                if(this.valid) {
                    let strategy = {
                        name: this.strategyName,
                        description: this.strategyDescription,
                    };
                    Repository.createStrategy(strategy).then(async (response) => {
                        if (response.status < 400) {
                            await Repository.addStrategy(response.data.id).then(async (responseLinking) => {
                                if (responseLinking.status < 400) {
                                    await Repository.allStrategiesOfUser().then((response) => {
                                        this.setStrategies(response.data);
                                    });
                                    this.$emit('closeWindow');
                                }
                            });
                        }
                    });
                }
                else
                    alert(this.$t('alertMessage'));
            },
        }
    }
</script>

<style scoped>

</style>


